// Meta's registered OAuth redirect URI (LOGIN_URL in telegramquickchat/meta/meta_auth/const.py).
// The callback page posts its result with targetOrigin '*', so every opener has to check
// the origin itself — deriving it here keeps it from drifting away from the redirect URI.
export const META_REDIRECT_URI = 'https://meta.quickchat.ai/login';
export const META_CALLBACK_ORIGIN = new URL(META_REDIRECT_URI).origin;

// Messenger OAuth stages the discovered Pages instead of connecting one, so a `success`
// callback carrying this reason_code means "pick a Page", not "connected".
export const MESSENGER_AWAITING_PAGE_SELECTION = 'awaiting_page_selection';
export const MESSENGER_NO_PAGE_SELECTED = 'no_page_selected';
export const MESSENGER_CONNECTION_RESULT = 'messenger_connection_result';
